import { ConditionGroup } from './reactionClasses';

export const conditionGroupsMeta = {
  coupling_reagent: {
    icon: 'handshake',
    color: 'indigo',
  },
  solvent: {
    icon: 'water_drop',
    color: 'cyan',
  },
  temperature: {
    icon: 'device_thermostat',
    color: 'tomato',
    unit: '°C',
  },
  acyl_transfer_reagent: {
    icon: 'call_split',
    color: 'grass',
  },
  catalyst: {
    icon: 'support',
    color: 'blue',
  },
  time_in_h: {
    icon: 'schedule',
    color: 'orange',
    unit: 'h',
  },
  base: {
    icon: 'salinity',
    color: 'grass',
  },
} as const;

export function getConditionGroupValues(conditionGroup: ConditionGroup) {
  return Object.fromEntries(
    Object.entries(conditionGroup).map(([key, value]) => [key, value.smiles])
  );
}
